import React, { useMemo } from 'react';
import { Formik, ErrorMessage } from 'formik';
import { CSSTransition } from 'react-transition-group';

import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicInput from '../../../../components/BasicInput';
import BasicLabel from '../../../../components/BasicLabel';
import BasicSubmitButton from '../../../../components/BasicSubmitButton';
import LoadMask from '../../../../components/LoadMask';
import TextEditor from '../../../../components/TextEditor';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import ENDPOINT from '../../../../constants/endpoints';
import {convertEditorStateToHtml, convertHtmlToEditorState} from '../../../../helpers/formik';
import useApi from '../../../../hooks/useApi';
import {FirmAboutEditDescriptionBlockFormValidationSchema} from './validate';

const FirmAboutEditDescriptionBlockForm = props => {
  const {
    params: { values, type },
    actions: { proceed, dismiss, handleError },
  } = props;

  const api = useApi();

  const initialValues = useMemo(
    () => ({
      Title: values.Title,
      Content: convertHtmlToEditorState(values.Content),
      type: type,
      blockId: values.FirmInfoBlockID || 0,
      id: values.firmId,
    }),
    []
  );

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    api.post(
      ENDPOINT.FORM.SAVE.FIRM_ABOUT_BLOCK,
      {
        ...values,
        Content: convertEditorStateToHtml(values.Content),
      },
      {
        handleError: response => {
          setSubmitting(false);
          handleError(response, setErrors);
        },
        handleSuccess: response => {
          proceed(response);
        },
      }
    );
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <Formik
          initialValues={initialValues}
          validationSchema={FirmAboutEditDescriptionBlockFormValidationSchema}
          onSubmit={onSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
          }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask />}
              <div className="form__group form__group--compact">
                <BasicInput
                  label="Section name"
                  required={true}
                  name="Title"
                  inputType="text"
                  content={values.Title}
                  placeholder="Title..."
                  controlFunc={handleChange}
                  isValid={(!errors.Title && touched.Title) || !touched.Title}
                  touchFunc={handleBlur}
                  labelStyles={{ fontWeight: 'bold' }}
                />

                <ErrorMessage
                  name="Title"
                  render={message => (
                    <div className="form__error">{message}</div>
                  )}
                />
              </div>
              <div className="form__group form__group--compact">
                <BasicLabel
                  name="Content"
                  required={true}
                  text="Description"
                  styles={{
                    fontWeight: 'bold',
                    marginTop: '15px',
                  }}
                />

                <TextEditor
                  name="Content"
                  editorState={values.Content}
                  controlFunc={setFieldValue}
                  touchFunc={setFieldTouched}
                  isValid={
                    (!errors.Content && !!touched.Content) || !touched.Content
                  }
                />

                <ErrorMessage
                  name="Content"
                  render={message => (
                    <div className="form__error">{message}</div>
                  )}
                />
              </div>
              <div className="form__controls form__controls--compact">
                <BasicButtonGroup groupStyles={{ width: '100%' }}>
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={true}
                    btnTextColor="#27282d"
                    btnText="Save"
                  />

                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default FirmAboutEditDescriptionBlockForm;
